module.exports = __webpack_public_path__ + "img/logo-180x48.de241678.svg";